import { PaypalButtonComponent } from './paypal-button/paypal-button.component';
import { RestService } from 'src/app/services/rest.service';
import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation';
import { stagger80ms } from 'src/@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { MatDialog } from '@angular/material/dialog';
import {TranslateService} from "@ngx-translate/core";
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { EmailAlreadyModalComponent } from './email-already-modal/email-already-modal.component';
import { GuiService } from 'src/app/services/gui.service';
import { RegSubInfoComponent } from './reg-sub-info/reg-sub-info.component';

const checkArray = ["GETSTRONGERSERE","TESTCSP0000","TESTCSP0001","TESTCSP0002","PROMOSTART","STRONGERELE10","STRONGERSERE","STRONGERWITHSERE"];
@Component({
  selector: 'vex-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  animations: [
    stagger80ms,
    fadeInUp400ms,
    scaleIn400ms,
    fadeInRight400ms
  ]
})
export class RegisterComponent implements OnInit {

  accountFormGroup: UntypedFormGroup;
  passwordFormGroup: UntypedFormGroup;
  confirmFormGroup: UntypedFormGroup;

  verticalPlanFormGroup: UntypedFormGroup;
  verticalAccountFormGroup: UntypedFormGroup;
  verticalPasswordFormGroup: UntypedFormGroup;
  verticalPaymentFormGroup: UntypedFormGroup;
  verticalConfirmFormGroup: UntypedFormGroup;

  isPromoValid: boolean = false;
  countryOptions = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Uganda","Ukraine","United Arab Emirates","United States","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

  passwordInputType = 'password';
  selectedProgram: any;
  subs:any = [];
  showMiniSpinner: any
  platform: any;
  iconFlag: string

  subs_M: any = [];
  subs_Q: any = [];
  subs_H: any = [];
  subs_Y: any = [];
  avaiable_duration: any = []
  default_selection: any = {
    duration: 'M',
    type: 'GOLD'
  }

  promos = [
    {
      code: 'GENNAIO24',
      identifier: ["633adc3969be1503611544ca"]
    },
    {
      code: 'NEW24',
      identifier: ["633adc3969be1503611544ca"]
    },
    {
      code: 'COMEBACK24',
      identifier: ["633adc3969be1503611544ca"]
    }
  ];

  pricePromo

  constructor(private fb: UntypedFormBuilder,
              private cd: ChangeDetectorRef,
              private snackbar: MatSnackBar,
              private restService: RestService,
              private router: Router,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              public translate: TranslateService,
              public guiService: GuiService
  ) {
    translate.addLangs(['en', 'it']);
                translate.setDefaultLang('it');

                const browserLang = translate.getBrowserLang();
                translate.use(browserLang.match(/en|it/) ? browserLang : 'it');
                if(browserLang == 'it'){
                  this.iconFlag = 'flag:italy'
                }else{
                  this.iconFlag = 'flag:united-states'
                }
  }

  ngOnInit() {
    this.getUtils();
    this.platform = this.route.snapshot.paramMap.get('device')
    this.showMiniSpinner = false
    setTimeout(()=>this.guiService.showSpinner = false,0)
    this.getSubs()
    this.getMockPromoCodes()
    /**
     * Vertical Stepper
     * @type {FormGroup}
     */

     this.verticalPlanFormGroup = this.fb.group({
    });

    this.verticalAccountFormGroup = this.fb.group({
      name: [null, Validators.required],
      lastname: [null, Validators.required],
      email: [null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      country: [null, Validators.required],
      birthday: [null, Validators.required]
    });


    this.verticalPasswordFormGroup = this.fb.group({
      password: [
        null,
        Validators.compose(
          [
            Validators.required,
            Validators.minLength(6)
          ]
        )
      ],
      passwordConfirm: [null, Validators.compose(
        [
          Validators.required,
          Validators.minLength(6)
        ]
      )]
    });

    this.verticalPaymentFormGroup = this.fb.group({
      payment: [],
      card_name: [],
      card_number: [],
      card_expire: [],
      coupon: []
    });

    this.verticalConfirmFormGroup = this.fb.group({
      terms: [null, Validators.requiredTrue],
      policy: [null],
      newsletter: []
    });
  }

  showPassword() {
    this.passwordInputType = 'text';
    this.cd.markForCheck();
  }

  hidePassword() {
    this.passwordInputType = 'password';
    this.cd.markForCheck();
  }

  getSubs(){
    this.restService.getService('subscriptions', 'actives').subscribe((ris)=>{
      this.subs = []
      for(let i = 0; i< ris.length; i++){
        let sub = ris[i]
        if(sub.duration == 'M'){
          let now = moment()
          if(sub.endDate && moment(sub.endDate,'x').isAfter(now)){
            this.subs_M.push(sub)
            this.avaiable_duration.includes('M') ? null : this.avaiable_duration.push('M')
          }
        }else if(sub.duration == 'Q'){
          let now = moment()
          if(sub.endDate && moment(sub.endDate,'x').isAfter(now)){
            this.subs_Q.push(sub)
            this.avaiable_duration.includes('Q') ? null : this.avaiable_duration.push('Q')
          }
        } else if(sub.duration == 'H'){
          let now = moment()
          if(sub.endDate && moment(sub.endDate,'x').isAfter(now)){
            this.subs_H.push(sub)
            this.avaiable_duration.includes('H') ? null : this.avaiable_duration.push('H')
          }
        } else if(sub.duration == 'Y'){
          let now = moment()
          if(sub.endDate && moment(sub.endDate,'x').isAfter(now)){
            this.subs_Y.push(sub)
            this.avaiable_duration.includes('Y') ? null : this.avaiable_duration.push('Y')
          }
        }
      }
      this.subs_M.reverse()
      this.subs_Q.reverse()
      this.subs_H.reverse()
      this.subs_Y.reverse()

      console.debug('M',this.subs_M)
      console.debug('Q',this.subs_Q)
      console.debug('H',this.subs_H)
      console.debug('Y',this.subs_Y)
      console.debug(this.avaiable_duration)
    })
  }

  goTo(param){
    if(param == 'terms'){
      window.open('https://itsdesifit.com/terms-of-use/','_blank');
    }if(param == 'policy'){
      window.open('https://itsdesifit.com/privacy-policy/','_blank');
    }if(param == 'itsdesifit'){
      window.open('https://itsdesifit.com','_blank');
    }
  }

  submit() {
    this.findPlanObj()
    let newAccount = {
      subscriptionId: this.selectedProgram.id,
      name: this.verticalAccountFormGroup.value.name,
      lastName: this.verticalAccountFormGroup.value.lastname,
      email: this.verticalAccountFormGroup.value.email.toLowerCase(),
      birthDate: this.verticalAccountFormGroup.value.birthday,
      country: this.verticalAccountFormGroup.value.country,
      password: this.verticalPasswordFormGroup.value.password,
      paymentType: 'CHARGEBEE',
      newsLetterRegistration: true,
      promotionCodesToBeAdded: this.verticalPaymentFormGroup.value.coupon != null && this.verticalPaymentFormGroup.value.coupon != '' && this.isPromoValid ? [this.verticalPaymentFormGroup.value.coupon] : []
  }

  this.showMiniSpinner = true
  this.guiService.showSpinner = true

   this.restService.postService('register','', newAccount).subscribe({
   next: (ris)=>{
    let tkn
    let login = {
      email: this.verticalAccountFormGroup.value.email.toLowerCase(),
      password: this.verticalPasswordFormGroup.value.password
    }
      let checkout = {
        "cancelPageUrl": environment.baseURL.base +"/#/auth/payment-rejected",
        "successPageUrl": this.platform == 'mobile' ? environment.baseURL.base +"/#/auth/application" : environment.baseURL.base +"/#/auth/register-confirm"
      }

      this.restService.doLogin('', login).subscribe((res)=>{
        tkn = res.body["token"]
        this.restService.chargeBeeCheckout('chargebee','/checkout-new',checkout,tkn).subscribe((response)=>{
          console.debug(response)
          window.location.href = response.checkoutNewUrl
          this.guiService.showSpinner = false
          this.showMiniSpinner = false
        })
      })

   },
   error: (err)=> {
    if(err.status == 400) {
      let msg = err.error && err.error.errors && err.error.errors[0] ? err.error.errors[0] : "OOPS. Please contact support"

      if(err.error && err.error.errors && err.error.errors[0] == 'Email already in use.'){
        this.dialog.open(EmailAlreadyModalComponent,{
        disableClose: true,
        hasBackdrop: true
      })
      }else{
        this.restService.openSnackBar(msg, this.translate.instant("MSG.CLOSE"), 'error');
      }
    }
    this.showMiniSpinner = false
    this.guiService.showSpinner = false
  }
  });

  }

  checkPromo(templateRef:any){
    this.findPlanObj()
    if(this.verticalPaymentFormGroup.value.coupon && this.verticalPaymentFormGroup.value.coupon.length > 3){
      this.restService.getService('promotions', 'validate/' + this.verticalPaymentFormGroup.value.coupon+'/'+this.selectedProgram.id).subscribe((ris)=>{
       if(this.promos.find(x => x.code === this.verticalPaymentFormGroup.value.coupon) && ris == true){
        console.debug('IF',this.selectedProgram)
        if(this.promos.find(x => x.code === this.verticalPaymentFormGroup.value.coupon).identifier.includes(this.selectedProgram.id) === true){
          this.isPromoValid = true
        }else{
          this.isPromoValid = false
          let dialogRef = this.dialog.open(templateRef,{
            width:'450px'
          })
          dialogRef.afterOpened().subscribe(_ =>{
            setTimeout(() => {
              dialogRef.close();
            }, 2500);
          })
        }
       }else{
        console.debug('ELSE')
        this.isPromoValid = ris
       }
      })
    }
  }
  forceEmailLowerCase(){
    this.verticalAccountFormGroup.controls['email'].setValue(this.verticalAccountFormGroup.value.email.toLowerCase())
  }

  selectPlan(type: any,templateRef){
    this.default_selection.type = type
    console.debug(this.default_selection.type)
    this.verticalPaymentFormGroup.value.coupon && this.verticalPaymentFormGroup.value.coupon.length > 3 ? this.checkPromo(templateRef) : null
  }

  selectDuration(duration:any,templateRef){
    this.default_selection.duration = duration
    console.debug(this.default_selection.duration)
    this.verticalPaymentFormGroup.value.coupon && this.verticalPaymentFormGroup.value.coupon.length > 3 ? this.checkPromo(templateRef) : null
  }

  findPlanObj(){
    let obj
    if(this.default_selection.duration == 'M'){
      if(this.default_selection.type == 'GOLD'){
        obj = this.subs_M.find(o => o.type === 'GOLD');
      }else if(this.default_selection.type == 'DIAMOND'){
        obj = this.subs_M.find(o => o.type === 'DIAMOND');
      }
    }
    if(this.default_selection.duration == 'Q'){
      if(this.default_selection.type == 'GOLD'){
        obj = this.subs_Q.find(o => o.type === 'GOLD');
      }else if(this.default_selection.type == 'DIAMOND'){
        obj = this.subs_Q.find(o => o.type === 'DIAMOND');
      }
    }
    if(this.default_selection.duration == 'H'){
      if(this.default_selection.type == 'GOLD'){
        obj = this.subs_H.find(o => o.type === 'GOLD');
      }else if(this.default_selection.type == 'DIAMOND'){
        obj = this.subs_H.find(o => o.type === 'DIAMOND');
      }
    }
    if(this.default_selection.duration == 'Y'){
      if(this.default_selection.type == 'GOLD'){
        obj = this.subs_Y.find(o => o.type === 'GOLD');
      }else if(this.default_selection.type == 'DIAMOND'){
        obj = this.subs_Y.find(o => o.type === 'DIAMOND');
      }
    }

    return this.selectedProgram = obj
  }

  showSubDetails(sub:any){
    console.debug('dettaglio',sub)
    this.dialog.open(RegSubInfoComponent,{
      data: sub,
      panelClass: "reg-sub-info-modalbox",
      width: '90vw',
      maxWidth: '600px'
    })
  }

  getMockPromoCodes(){
    this.restService.getService('mock','promos').subscribe((ris)=>{
      this.promos = ris
    })
  }

  getUtils(){
    this.restService.getService('util','').subscribe({
      next: (ris)=>{
        this.pricePromo = ris?.price_promo;

        const today = moment().format('YYYY-MM-DD');
        const from = moment(new Date(this.pricePromo?.validity?.from)).format('YYYY-MM-DD');
        const to = moment(new Date(this.pricePromo?.validity?.to)).format('YYYY-MM-DD');

        if(moment(today).isSameOrAfter(from) && moment(today).isSameOrBefore(to)){
          console.debug("E' NEL RANGE")
          this.pricePromo.dateValid = true;
        }else{
          this.pricePromo.dateValid = false;
        }

        /* GESTIONE PIANO DI DEFAULT SELEZIONATO */
        if(ris && ris.price_promo && ris.price_promo.default_selection && ris.price_promo.default_selection.register){
          const def = ris.price_promo.default_selection.register;

          this.default_selection = {
            duration: def.duration,
            type: def.type
          }
        }
      },
      error: (e) =>{

      }
    })
  }
}
